import { useCallback, useContext } from "react";
import { CardEditionPanel } from "@radarly/models/panel";
import { Action } from "../action";
import ChannelContext from "../context";
export function useOpenCardEditionPanel() {
  const { dispatch } = useContext(ChannelContext);
  return useCallback(
    (
      card: CardEditionPanel["card"],
      onValidate: CardEditionPanel["onValidate"],
      pageColors: CardEditionPanel["pageColors"],
      editedPage: CardEditionPanel["editedPage"],
      setAIContext: CardEditionPanel["setAIContext"],
      globalPeriod?: CardEditionPanel["globalPeriod"]
    ) => {
      dispatch(
        Action.panelOpened({
          type: "card-edition",
          card,
          editedPage,
          setAIContext,
          onValidate,
          pageColors,
          globalPeriod,
        })
      );
    },
    [dispatch]
  );
}
